import EfScrollAni from '@/efscrollani';
import { useProductStore } from '../ProductProvider';
import { IPageStatus } from '../config/IPageStatus';
import StatusA from './StatusA';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className="page-product">
            <StatusA />
        </div>
    );
}
